import { Button } from 'react-bootstrap'
import './red.css'

export default function Red() {
  return (
    <section className='red section__padding' id='red'>
      <div className='red__content'>
        <div className="d-flex justify-content-center mt-4">
          <Button 
              href='/hazte-amiga' 
              className='whydoit_button'
          >HAZTE AMIGA</Button>
        </div>
      </div>
    </section>
  )
}